<template>
    <div>
        <Header v-if="!isWx" :title="title" />
        <!-- 选项卡 -->
        <ul class="tab" :style="{'top': isWx ? '0' : '60px'}">
            <li @click="checkTab(0)" :class="{active: tabIndex === 0}">最新<span :class="{line: tabIndex === 0}"></span></li>
            <li @click="checkTab(1)" :class="{active: tabIndex === 1}">最热<span :class="{line: tabIndex === 1}"></span></li>
        </ul>
        <div class="tabContent" :style="{'padding-top': isWx ? '72px' : '132px'}">
            <!-- 最新 -->
            <div v-show="tabIndex === 0">
                <waterfall 
                    :col='col' 
                    :data="newList"
                    :width="itemWidth" 
                    :gutterWidth="gutterWidth"
                    @loadmore="loadmore"  
                >
                    <template>
                        <div v-for="item in newList" :key="item.id">
                            <WaterfallList :data="item" />
                        </div>
                    </template>
                </waterfall>
                 <div class="no-more" v-show="!newEmpty">加载中...</div>
                <div class="no-more" v-show="newEmpty">没有更多了</div>
            </div>
            <!-- 最热 -->
            <div v-show="tabIndex === 1">
                <waterfall 
                    :col='col2' 
                    :data="hotList"
                    :width="itemWidth" 
                    :gutterWidth="gutterWidth"
                    @loadmore="loadmore"  
                >
                    <template>
                        <div v-for="item in hotList" :key="item.id">
                            <WaterfallList :data="item" />
                        </div>
                    </template>
                </waterfall>
                 <div class="no-more" v-show="!hotEmpty">加载中...</div>
                <div class="no-more" v-show="hotEmpty">没有更多了</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getPlateList } from '@/request/api'
import { Header, WaterfallList } from "@/components";
import { checkWx } from '@/pages/index/custom'

export default {
    components: {
        Header,
        WaterfallList
    },
    data() {
        return {
            title: "",
            tabIndex: 0,
            // 最新
            col: 2, // 瀑布流列数
            page: 1,  // 瀑布流分页
            newList: [],
            // 最热
            col2: 2, // 瀑布流列数
            page2: 1,  // 瀑布流分页
            hotList: [],
            newEmpty: false, // 加载完毕
            hotEmpty: false, // 加载完毕
            isWx: true
        }
    },
    methods: {
        checkTab(index) {
            this.tabIndex = index;
            if(index === 0) {
                if(this.newList.length <= 0) this.initList();
            } else if(index === 1) {
                if(this.hotList.length <= 0) this.initList();
            }
        },
        loadmore(){
            if(this.tabIndex === 0) {
                if(!this.newEmpty) {
                    this.initList();
                }
            } else if(this.tabIndex === 1) {
                if(!this.hotEmpty) {
                    this.initList();
                }
            }
        },
        // 获取列表
        initList() {
            let type = this.tabIndex === 0 ? 1 : 2;
            let {id, name} = this.$route.query;
            this.title = name;
            getPlateList({
                page: type === 1 ? this.page : this.page2,
                pcount: 8,
                type: type,
                plate_id: id
            }).then( res => {
                let {posts, error_code} = res;
                if(error_code === 0) {
                    if(type === 1) {
                        if(posts.length > 0) {
                            this.newList = this.newList.concat(posts)
                        } else {
                            this.newEmpty = true
                        }
                    } else {
                        if(posts.length > 0) {
                            this.hotList = this.hotList.concat(posts)
                        } else {
                            this.hotEmpty = true
                        }
                    }
                    if(this.tabIndex === 0) {
                        this.page = this.page + 1;
                    } else {
                        this.page2 = this.page2 + 1;
                    }
                }
            }).catch( error => {
                console.log(error)
            })
        }
    },
    computed:{
        itemWidth(){  
            return Math.floor((document.documentElement.clientWidth-55)/2)
        },
        gutterWidth(){
            return 15
        }
    },
    created() {
        this.isWx = checkWx()
        this.initList();
    }
}
</script>

<style lang="less" scoped>
    .no-more {
        text-align: center;
        height: 1.875rem;
        color: #ccc;
        font-size: 14px;
    }
    .tabContent {
        padding: 0 1.25rem 3.75rem 1.25rem;
        box-sizing: border-box;
    }
    .tab {
        padding: 0 20px;
        background-color: #fff;
        position: fixed;
        left: 0;
        z-index: 1000;
        height: 3.75rem;
        width: 100%;
        box-sizing: border-box;
        li {
            float: left;
            margin-right: 1.5rem;
            font-size: 16px;
            font-weight: 400;
            color: rgba(34,34,34,1);
            position: relative;
            height: 100%;
            line-height: 3.75rem;
            transition: all .3s;
        }
        li.active {
            font-size: 24px;
            font-weight: 600;
        }
        .line {
            position: absolute;
            bottom: 8px;
            left: 50%;
            margin-left: -0.625rem;
            width: 1.25rem;
            height: .25rem;
            background-color: #FF4C67;
            box-shadow: 0px 2px 6px 0px #fd7c90;
            border-radius: 10px;
        }
        &::after {
            content: "";
            display: block;
            clear: both;
        }
    }
</style>